import * as React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { BaseForm } from './Base';
import * as dateFormat from 'dateformat';
import theme from '../../utils/theme';

const base = (props: any) => {
  const opacity = props.disabled ? 'o-50' : 'o-100';

  return `${theme.form.field.input} ${opacity}`;
};

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export interface Props extends InputProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export const DateTime = (props: Props) => {
  return (
    <BaseForm label={props.label} id={props.id} tooltip={props.tooltip}>
      <DayPickerInput
        value={dateFormat(props.defaultValue, 'dd/mm/yyyy')}
        format="DD/MM/YYYY"
        placeholder="DD/MM/YYYY"
        onDayChange={(value: Date) => props.onValueChange(props.field, value)}
        inputProps={{
          type: 'text',
          className: base(props),
        }}
        dayPickerProps={{
          selectedDays: props.defaultValue,
        }}
      />
    </BaseForm>
  );
};
